import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchItemCategoriesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemCategoriesDossierByIdController.php
* @route '/api/dossier-item-categories/{dossier}'
*/
const FetchItemCategoriesDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemCategoriesDossierByIdController.url(args, options),
    method: 'get',
})

FetchItemCategoriesDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-item-categories/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchItemCategoriesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemCategoriesDossierByIdController.php
* @route '/api/dossier-item-categories/{dossier}'
*/
FetchItemCategoriesDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchItemCategoriesDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchItemCategoriesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemCategoriesDossierByIdController.php
* @route '/api/dossier-item-categories/{dossier}'
*/
FetchItemCategoriesDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchItemCategoriesDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchItemCategoriesDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchItemCategoriesDossierByIdController.php
* @route '/api/dossier-item-categories/{dossier}'
*/
FetchItemCategoriesDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchItemCategoriesDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchItemCategoriesDossierByIdController